import * as React from 'react';
import { useSelector } from 'react-redux';

import { FAKE_RUSSIA_REGION } from '../../../constants/fakeRegions';
import { MOSCOW_ID } from '../../../constants/geo';
import { selectCurrentRegion } from '../../../selectors/currentRegion';
import { selectRequestLocationId } from '../../../selectors/location/selectRequestLocationId';
import { IRegion } from '../../../types/microfrontends';

export function useRegion(): IRegion {
  const region = useSelector(selectCurrentRegion);
  const requestLocationId = useSelector(selectRequestLocationId) ?? MOSCOW_ID;

  return React.useMemo(() => {
    return region.id === FAKE_RUSSIA_REGION.id ? { id: requestLocationId } : region;
  }, [region, requestLocationId]);
}
